import { apiUc } from '../../../http';
import serviceCRUD from '../../../services/ServiceCRUDFLEXUC';

class TeamService extends serviceCRUD {
  constructor() {
    super('/api/user-team');
  }

  changeStatus(id, disabled) {
    return apiUc.patch(`${this.path}/status/${id}`, {
      disabled
    });
  }
}

export default new TeamService();
